import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import {ThemeProvider} from "../../../providers/theme/theme";

@Component({
  selector: 'page-other-pk-modal',
  templateUrl: 'other-pk-modal.html'
})
export class OtherPkModalPage {

  constructor(private viewCtrl: ViewController,
              private themeProvider: ThemeProvider) {

  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  confirm(choice) {
    this.viewCtrl.dismiss(choice);
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/other-pk-modal/other-pk-modal.ts